import React, { Component, Fragment } from 'react';
import { browserHistory, Link } from 'react-router';
import ReactPaginate from 'react-paginate';
import Alert from 'components/alerts/Alert/Alert';
import moment from 'moment-timezone';
import classnames from 'classnames';

const warningSymbol = String.fromCharCode(9888);
const checkSymbol = String.fromCharCode(9989);
const clockSymbol = String.fromCharCode(9200);
const xSymbol = String.fromCharCode(10060);

class TeacherReservationListCompact extends Component {
  statusSymbol = (status) => {
    switch (status) {
      case 'Issue':
        return warningSymbol;
      case 'Under Review':
        return warningSymbol;
      case 'Refunded':
        return warningSymbol;
      case 'Booked':
        return clockSymbol;
      case 'Complete':
        return checkSymbol;
      case 'Canceled':
        return xSymbol;
      case 'Pending':
        return warningSymbol;
      default:
        return '';
    }
  }

  showIssueDetails = (appointment) => {
    const { issue } = appointment;
    issue.teacher = this.props.currentUser;
    issue.reporter = appointment.student;
    browserHistory.push({
      pathname: `/teacher/schedule/reservations/${appointment.id}/issue`,
      state: { issue, appointment }
    });
  }

  changePage = (data) => {
    this.setState({ currentPage: data.selected });
    this.props.handlePaginationClick(data);
  }

  formatListingTitle = () => {
    const {
      total, page, pageSize, reservations
    } = this.props;
    const pageStart = page * pageSize + 1;
    const pageEnd = pageStart + (reservations.length || 0) - 1;

    return `${pageStart} – ${pageEnd} of ${total} Lesson${total === 1 ? '' : 's'}`;
  }

  handleConfirmButtonClick = (reservation) => {
    this.props.handleConfirmButtonClick(reservation);
  }

  render() {
    const {
      reservations, total, page, pageSize, handleConfirmButtonClick
    } = this.props;

    return (
      <div className="teacher-reservation-list">
        {reservations.length > 0 ? (
          <Fragment>
            <p className="teacher-reservation-list__title">
              {this.formatListingTitle()}
            </p>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Student</th>
                  <th scope="col">
                    Date/Time <small>(Shown in local - {moment.tz.guess()})</small>
                  </th>
                  <th scope="col">Language</th>
                  <th scope="col">Issue</th>
                </tr>
              </thead>
              <tbody>
                {reservations.map(reservation => {
                  return (
                    <tr key={reservation.id}>
                      <th scope="row" className={classnames({
                        'text-danger': reservation.statusForClient === 'Pending'
                      })}>
                        {
                          handleConfirmButtonClick && (<div>
                            <button
                              type="button"
                              className="btn btn-blue btn-cursor btn-sm px-4 py-2"
                              onClick={() => this.handleConfirmButtonClick(reservation)}
                            >
                              Confirm
                            </button>
                          </div>)
                        }
                        {this.statusSymbol(reservation.statusForClient)}{' '}
                        {reservation.statusForClient}
                      </th>
                      <td>{reservation.student.name}</td>
                      <td>
                        {moment
                          .utc(reservation.startTime)
                          .local()
                          .format('MMM DD, YYYY h:mma')}
                      </td>
                      <td>{reservation.service.description}</td>
                      <td>
                        {reservation.issue && (
                          <Link
                            to={`/teacher/issues/${reservation.issue.id}`}
                            onClick={event => {
                              event.preventDefault();
                              this.showIssueDetails(reservation);
                            }}
                          >
                            Issue Details
                          </Link>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {page >= 0 && (
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                pageCount={total / pageSize}
                forcePage={page}
                marginPagesDisplayed={total / pageSize}
                pageRangeDisplayed={1}
                onPageChange={this.changePage}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
              />
            )}
          </Fragment>
        ) : (
          <Alert alertType="warning" className="mt-2">
            <h4>No reservations</h4>
          </Alert>
        )}
      </div>
    );
  }
}

export default TeacherReservationListCompact;



// WEBPACK FOOTER //
// ./src/components/TeacherReservationListCompact/index.js